import clsx from 'clsx';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { options } from '../../constants';
import { SidebarContainer } from './style';
import { SidebarProps } from './types';
import { BetaIcon, CrownSmallIcon } from 'icons';
import BillingService from 'core/services/service.billing';
import { useOrganizationConfig } from 'views/main/organization/schedules';
import UpgradePlanModal from 'components/upgradeplan.modal';
import { IAppState } from 'core/interfaces/IAppState';
import { shallowEqual, useSelector } from 'react-redux';

function Sidebar({ currentRoute }: SidebarProps) {
  const history = useHistory();
  const org = useOrganizationConfig().organization;

  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Only redirect if currentRoute is not in options AND is not a valid analytics path
  useEffect(() => {
    const isValidRoute = options.some(option => option.value === currentRoute);

    if (!isValidRoute) {
      history.push(options[0].value);
    }
  }, [currentRoute, history]);

  const isFeatureDisabled = useMemo(() => {
    return org
      ? BillingService.isFeatureDisabled({ organization: org }, 'on-call-hours-per-user')
      : false;
  }, [org, BillingService]);

  const renderIcon = (option: any) => {
    return (
      <div className="option">
        <div className="icon">{option.icon}</div>
        <div className="label">{option.tabName}</div>
        {option.isBeta && <BetaIcon />}
        {option.label === 'On Call Hours by User' && isFeatureDisabled && (
          <CrownSmallIcon
            className="pro"
            style={{
              position: 'absolute',
              marginLeft: '170px',
              marginTop: '-20px',
              height: 14,
              width: 14,
            }}
          />
        )}
      </div>
    );
  };

  return (
    <SidebarContainer>
      <div className="header">
        <div className="title">Analytics</div>
      </div>
      <div className="options">
        {options.map(option => (
          <div
            className={clsx('option-container', {
              selected: currentRoute === option.value,
            })}
            key={option.value}
            onClick={() => {
              if (currentRoute !== option.value) {
                if (option.label === 'On Call Hours by User') {
                  if (isFeatureDisabled) setShowUpgradeModal(true);
                  else history.push(option.value);
                } else history.push(option.value);
              }
            }}
          >
            {renderIcon(option)}
          </div>
        ))}
      </div>
      <UpgradePlanModal
        hasBillingPermission={BillingService.hasManageBillingPermission({ organization: org })}
        showModal={showUpgradeModal}
        onCancel={() => setShowUpgradeModal(false)}
        message={BillingService.getMessage(0, 'on-call-hours-per-user', { organization: org })}
        header={BillingService.getHeader(0, 'on-call-hours-per-user', { organization: org })}
        onUpgrade={() => setShowUpgradeModal(false)}
      />
    </SidebarContainer>
  );
}

export default Sidebar;
